import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/SecondNav.css";
import {
  brandData,
  editData,
  fitData,
  productData,
  shoeData,
} from "../rawData/MenuData";

const SecondNavbar = () => {
  const navigate = useNavigate();

  const checkeURl = () => {
    if (
      window.location.pathname === "/NewArrival" ||
      window.location.pathname === "/Men/NewArrival" ||
      window.location.pathname === "/Women/NewArrival"
    ) {
      return;
    } else if (window.location.pathname === "/") {
      navigate("/NewArrival");
    } else {
      navigate(window.location.pathname + "/NewArrival");
    }
  };

  return (
    <>
      <div className="Secondmain-container p-2">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
              <div className="navbar-nav  MenuBar">
                <li>
                  <a
                    className="nav-link NavLink active"
                    onClick={() => checkeURl()}
                  >
                    New Arrivals
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      <h6>Shop by product</h6>
                      {productData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>

                    <ul class="list-group p-2">
                      <h6>Shop by fits</h6>
                      {fitData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}

                      <h6>Shop by Edit</h6>
                      {editData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>

                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>

                    <ul class="list-group p-2 thirdUl">
                      <div className="Menu-Img mb-3">
                        <img src="/images/module1.jpg" alt="Image Not Found" />
                        <p>Back To School</p>
                      </div>
                      <div className="Menu-Img">
                        <img src="/images/module1.jpg" alt="Image Not Found" />
                        <p>Dresses</p>
                      </div>
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink active" href="#">
                    Clothing
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      <h6>Shop by product</h6>
                      {productData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>

                    <ul class="list-group p-2">
                      <h6>Shop by fits</h6>
                      {fitData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}

                      <h6>Shop by Edit</h6>
                      {editData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>

                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>

                    <ul class="list-group p-2 thirdUl">
                      <div className="Menu-Img mb-3">
                        <img src="/images/module1.jpg" alt="Image Not Found" />
                        <p>Back To School</p>
                      </div>
                      <div className="Menu-Img">
                        <img src="/images/module1.jpg" alt="Image Not Found" />
                        <p>Dresses</p>
                      </div>
                    </ul>
                  </div>
                </li>

                <li>
                  <a className="nav-link NavLink" href="#">
                    Shoes
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>

                <li>
                  <a className="nav-link NavLink" href="#">
                    Bags
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    Accessories
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    Homeware
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    Sports
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    Shop by age
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    Brands
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    Gift
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    Sale
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <a className="nav-link NavLink" href="#">
                    All girls
                  </a>
                  <div className="BackMenu">
                    <ul class="list-group p-2">
                      {shoeData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                    <ul class="list-group p-2 thirdUl">
                      <h6>Shop by Brand</h6>
                      {brandData.map(({ item }) => (
                        <li class="list-group-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                </li>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default SecondNavbar;
